import { render, staticRenderFns } from "./PlanBadge.vue?vue&type=template&id=5c4722dd&scoped=true&"
import script from "./PlanBadge.vue?vue&type=script&lang=js&"
export * from "./PlanBadge.vue?vue&type=script&lang=js&"
import style0 from "./PlanBadge.vue?vue&type=style&index=0&id=5c4722dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4722dd",
  null
  
)

export default component.exports